<div class="py-4">
  <mat-card class="px-3">
    <mat-card-header>
      <shared-title>Reservas</shared-title>
      <button
        mat-icon-button
        matTooltip="Limpiar formulario"
        matTooltipPosition="right"
        class="ml-5"
        (click)="clearForm()">
        <mat-icon>cleaning_services</mat-icon>
      </button>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="formReservation">
        <div class="grid">
          <mat-form-field
            class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Empresa</mat-label>
            <mat-select
              required
              [disabled]="!ValidBusiness_id()"
              (selectionChange)="chargueDataForm()"
              [(value)]="selectedBussines">
              @for (item of bussines; track item) {
                <mat-option [value]="item.idBusiness">{{
                  item.name
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field
            class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Selecciona fecha rango inicial</mat-label>
            <input
              matInput
              formControlName="startDate"
              [matDatepicker]="startDatePicker"
              readonly />
            <mat-datepicker-toggle
              matSuffix
              [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field
            class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Selecciona fecha rango final</mat-label>
            <input
              matInput
              formControlName="endDate"
              [matDatepicker]="endDatePicker"
              readonly />
            <mat-datepicker-toggle
              matSuffix
              [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field
            class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Tipo de puesto</mat-label>
            <mat-select formControlName="selectworkplacetype">
              @for (puesto of puestos; track puesto) {
                <mat-option
                  [value]="puesto.workplacetypeid"
                  (click)="filterWorkplacesByTypeId(puesto.workplacetypeid)">
                  {{ puesto.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field
            class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Edificio</mat-label>
            <mat-select formControlName="buildingId">
              @for (edificio of edificios; track edificio) {
                <mat-option
                  [value]="edificio.buildingid"
                  (click)="chargueFloorByBuilding(edificio.buildingid)">
                  {{ edificio.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field
            class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Nivel</mat-label>
            <mat-select formControlName="selectfloor">
              @for (floor of floors; track floor) {
                <mat-option
                  [value]="floor.floorid"
                  (click)="ChargeworkplaceByFloor(floor.floorid)">
                  {{ floor.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field
            class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Puesto de Trabajo</mat-label>
            <mat-select formControlName="selectworkplace">
              @for (workplace of workplacesFilter(); track workplace) {
                <mat-option [value]="workplace.workplaceid">
                  {{ workplace.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field
            class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="username" />
          </mat-form-field>
        </div>

        <div class="grid">
          <shared-button
            [icon]="'search'"
            color="accent"
            [disabled]="!ValidForms()"
            class="col-fixed"
            (click)="realizarConsulta()">
            Buscar
          </shared-button>
          <div class="col flex gap-3 justify-content-end">
            <shared-button
              [icon]="'save_alt'"
              [disabled]="!ValidForms()"
              (click)="downloadCsv()"
              color="accent">
              Descargar CSV
            </shared-button>
            <shared-button
              [icon]="'save_alt'"
              [disabled]="!ValidForms()"
              (click)="downloadPDF()"
              color="accent">
              Descargar PDF
            </shared-button>
          </div>
        </div>
      </form>
      <br />

      <div class="shadow-2 overflow-auto">
        <table mat-table [dataSource]="dataSource" matSort>
          <!-- Date Column -->
          <ng-container matColumnDef="initialDate" sticky>
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              ">
              Fecha Inicial
            </th>
            <td mat-cell *matCellDef="let element">{{ element.inicio }}</td>
          </ng-container>
          <!-- Date Column -->
          <ng-container matColumnDef="finalDate" sticky>
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              ">
              Fecha Final
            </th>
            <td mat-cell *matCellDef="let element">{{ element.fin }}</td>
          </ng-container>
          <!-- Name Column -->
          <ng-container matColumnDef="checkinDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Fecha Checkin
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.checkin }}
            </td>
          </ng-container>
          <!-- User Column -->
          <ng-container matColumnDef="checkoutDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Fecha Checkout
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.checkout }}
            </td>
          </ng-container>
          <!-- User Column -->
          <ng-container matColumnDef="firstname">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Primer Nombre
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.nombre }}
            </td>
          </ng-container>
          <!-- User Column -->
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Correo</th>
            <td mat-cell *matCellDef="let element">
              {{ element.correo }}
            </td>
          </ng-container>
          <!-- User Column -->
          <ng-container matColumnDef="workstation">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Puesto</th>
            <td mat-cell *matCellDef="let element">
              {{ element.puesto }}
            </td>
          </ng-container>
          <!-- User Column -->
          <ng-container matColumnDef="jobType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Tipo de Puesto
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.tipo_puesto }}
            </td>
          </ng-container>
          <!-- User Column -->
          <ng-container matColumnDef="level">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nivel</th>
            <td mat-cell *matCellDef="let element">
              {{ element.nivel }}
            </td>
          </ng-container>
          <ng-container matColumnDef="building">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Edificio</th>
            <td mat-cell *matCellDef="let element">
              {{ element.edificio }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

      <br />
      <mat-paginator
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
        aria-label="Select page of periodic elements">
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
